<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- Material Look-n-Feel -->
<div class="custom-field-number-container">
	<mat-form-field class="full-width">
		<mat-label>{{ customField?.view.label }}</mat-label>
		<input
			matInput
			automationId="customFieldListInput"
			class="custom-field-list-input"
			(focus)="internalFocused()"
			(blur)="internalBlurred()"
			[formControl]="internalField"
		/>
	</mat-form-field>
</div>
